// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__zvIkw","legacyBtn":"MutateMid_legacyBtn__IMw2-"};